<div class="text-center margin-bottom-50" id="presentation">
    <div class="ui container">
        <h2 class="margin-top-50">La liste des occasions</h2>
        <occasions-filter [occasionsFilters]="occasionsFilters" [occasionsSorting]="occasionsSorting"></occasions-filter>
        <occasions-list [occasions]="occasionsSorting"></occasions-list>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/content.html